import {Component, ContentChild, Input, TemplateRef} from '@angular/core';
import {TreeItem} from './tree-item';

@Component({
  selector: 'app-compo-tree',
  templateUrl: './compo-tree.component.html',
  styleUrls: ['./compo-tree.component.scss'],
})
export class CompoTreeComponent<T extends TreeItem> {

  @Input() treeData: T[] = [];
  @ContentChild(TemplateRef) nodeTemplate: TemplateRef<any>;

}
